module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og engelsk_primaerlogo_pos(svart).7e482ce4.png";